/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Features_CaptionInputs */

const en_gc_resources_features_caption = /** @type {(inputs: Gc_Resources_Features_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatting and charts in the upstream GridCraft app.`)
};

const zh_gc_resources_features_caption = /** @type {(inputs: Gc_Resources_Features_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`官方 GridCraft 应用中的格式设置与图表。`)
};

/**
* | output |
* | --- |
* | "Formatting and charts in the upstream GridCraft app." |
*
* @param {Gc_Resources_Features_CaptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_features_caption = /** @type {((inputs?: Gc_Resources_Features_CaptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Features_CaptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_features_caption(inputs)
	return zh_gc_resources_features_caption(inputs)
});
export { gc_resources_features_caption as "gc.resources.features.caption" }